import styled, { css } from 'styled-components';
import { elevationTransition } from '../Styles/Utils/elevation.js';

const StyledSVG = styled.svg `
    display: inline-block;
    vertical-align: middle;
    fill: ${(props) => props.color || props.theme.colors.Foreground};
    ${elevationTransition}

    ${({ color, hover }) => color !== hover &&
    css `
            &:hover {
                transition: fill 0.3s;
                fill: ${(props) => props.hover};
            }
        `}
`;
var StyledSVG$1 = StyledSVG;

export { StyledSVG$1 as default };
